module.exports = __webpack_public_path__ + "src/assets/img/m37.6bd6274f.svg";